'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, Suspense } from 'react'
import { usePostHog } from 'posthog-js/react'

function PostHogPageViewTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()

  useEffect(() => {
    if (pathname && posthog) {
      let url = pathname
      if (searchParams && searchParams.toString()) {
        url = `${pathname}?${searchParams.toString()}`
      }
      
      // Track pageview with additional context
      posthog.capture('$pageview', {
        $current_url: url,
        page_title: document.title,
        page_path: pathname,
        search_params: searchParams?.toString() || '',
        timestamp: new Date().toISOString()
      })
    }
  }, [pathname, searchParams, posthog])

  return null
}

export default function PostHogPageView() {
  return (
    <Suspense fallback={null}>
      <PostHogPageViewTracker />
    </Suspense>
  )
}